import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { _ } from '../../shared/utils';
import { LandingPageTile, ELEMENT_PARAMETERS, ELEMENT_STATE_NAME, SidebarPanelParams } from '~app/shared/tiles/home-tile.model';
import { SidebarPanelComponent } from '~app/sidebar/sidebar-panel/sidebar-panel.component';
import { AppMessageService } from '~app/shared/app-message/app-message.service';
import { SidebarService } from '~app/shared/sidebar/sidebar.service';
import { AuthService } from '~app/auth/auth.service';
import { InfluxGraphComponent } from '~app/influx/influx-graph/influx-graph.component';
import { Subject, takeUntil } from 'rxjs';
import { TenantConfig } from '~app/shared/map/layer/layer-definitions/tenant-config.type';
import { MeasurementTabId } from '~app/element-utils/element-actions/measurements-action/measurements-action.component'
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { MeasurementsActionService } from '~app/element-utils/element-actions/measurements-action/measurements-action.service';

/**
 * NOTE: refactor/rework, injection mechanism and component initialization / tab page activation.
 */
@Component({
  selector: 'qm-measurements-table',
  templateUrl: './measurements-table.component.html',
  styleUrls: ['./measurements-table.component.scss']
})
export class MeasurementsTableComponent extends SidebarPanelComponent implements OnDestroy {
  private static onShow$ = new Subject<void>();
  private ngUnsubscribe = new Subject<void>();

  public openTab: MeasurementTabId;

  @ViewChild('influxGraphMiso')
  private readonly influxGraphMiso?: InfluxGraphComponent;
  @ViewChild('influxGraphV2l')
  private readonly influxGraphV2l?: InfluxGraphComponent;

  public tenant: number;
  public tenantConfig: TenantConfig;
  protected componentName = MeasurementsTableComponent.getComponentName();

  constructor(protected sidebarService: SidebarService,
              protected appMessageService: AppMessageService,
              private authService: AuthService,
              private measurementsActionService: MeasurementsActionService,
              @Inject(ELEMENT_STATE_NAME) private elementName: string,
              @Inject(ELEMENT_PARAMETERS) public params: SidebarPanelParams) {
    super(appMessageService, sidebarService);
    this.tenant = this.authService.getTenant();
    this.tenantConfig = this.authService.getTenantConfig();
    if (this.params?.openTab) {
      this.openTab = this.params?.openTab as MeasurementTabId;
    }
    measurementsActionService.tabId$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe((activeTab: MeasurementTabId) => {
        this.openTab = activeTab;
    });
    MeasurementsTableComponent.onShow$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(() => {
      if (this.influxGraphMiso && this.openTab === 'MISONET') {
        this.influxGraphMiso.loadCurrentFeature();
      } else if (this.influxGraphV2l && this.openTab === 'V2L') {
        this.influxGraphV2l.loadCurrentFeature();
      }
    });
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

    /**
   * Configure the `LandingPageTile` for this component
   * @override
   */
  public static initTile(tile: LandingPageTile) {
    tile.description = _('Measurements table');
    tile.icon = 'far fa-chart-line';
    tile.title = _('Measurements table');
    tile.panel = MeasurementsTableComponent.getComponentName();
    tile.onShow = this.onShow$.next.bind(this.onShow$);
  }

  /**
   * @returns {string} Name of the component, used for panel and authorization APIs
   */
  public static getComponentName(): string {
    return 'measurements-table';
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    console.log(changeEvent.activeId);
    console.log(changeEvent.nextId);
    //// for future, emit active tab to some subject etc. if needed
  }
}
